import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = {
  class: "nav flex-column nav-pills me-3",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "tab-content flex-grow-1",
  id: "v-pills-tabContent"
}
const _hoisted_5 = { class: "table table-hover table-v2" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('deliveryMethodTexts'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, null, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: this.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.supportedMethods, (supportedMethod) => {
            return (_openBlock(), _createElementBlock("button", {
              key: supportedMethod,
              type: "button",
              onClick: ($event: any) => (this.showTab(supportedMethod.code)),
              class: _normalizeClass(["nav-link text-start", {
            'active': _ctx.activeTab === supportedMethod.code,
          }])
            }, _toDisplayString(supportedMethod.description), 11, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.supportedMethods, (supportedMethod) => {
            return (_openBlock(), _createElementBlock("div", {
              key: supportedMethod,
              class: _normalizeClass(["tab-pane fade", {
            'show': _ctx.activeTab === supportedMethod.code,
            'active': _ctx.activeTab === supportedMethod.code,
          }])
            }, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_6, _toDisplayString(supportedMethod.description), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.types, (type) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "align-middle",
                      key: type
                    }, [
                      _createElementVNode("td", null, _toDisplayString(type.description), 1),
                      _createElementVNode("td", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          class: "btn btn-icon btn-primary ms-2",
                          to: this.goToDetail(supportedMethod.code, type.code)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}